// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add your styles here */
/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
*:not(dialog) {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

:root {
  font-size: 16px;
  --far-background-color: #eeeeee;
  --close-background-color: #cccccc;
  --primary-color: #020100;
  --secondary-color: #801a86;
  --accent-color: #e768f3;
}
body {
  background-color: var(--far-background-color);
  font-family: "Space Grotesk", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}
header {
  position: relative;
  max-width: 1300px;
}
.header-wrap::after {
  content: "";
  position: absolute;
  background-color: var(--secondary-color);
  transform: skewY(-10deg);
  transform-origin: top left;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
}
.header-wrap::after{
  animation: appear 1s ease-in-out forwards;
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.socials ul {
  list-style: none;
  display: flex;
  gap: 16px;
}
.socials {
  margin-top: 16px;
  align-self: flex-end;
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.about-me {
  background-color: var(--close-background-color);
  height: max-content;
  justify-content: center;
  align-items: flex-end;
}
.name-overlay {
  position: absolute;
  color: var(--primary-color);
  font-size: 2.5rem;
  font-weight: bold;
  width: max-content;
  text-shadow: 4px 4px var(--accent-color);
  z-index: 3;
  top: 4rem;
  left: 12%;
  height: max-content;
}
.about-me h1 {
  height: max-content;
}
main {
  width: 98vw;
}
.project-card {
  height: 350px;
  width: 320px;
  background-color: var(--far-background-color);
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: #020100 solid 4px;
  font-size: 0.875rem;
}
.project-link{
  display: flex;
  gap: 16px;
}
#projects{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap:16px;
  justify-items: center;
}
.my-work {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;
  padding: 16px;
}
.my-work h1 {
  font-size: 3rem;
  align-content: center;
}
.project-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.project-card-head h1 {
  font-size: 1.5rem;
}
.project-card-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
footer {
  margin-top: 32px;
  padding: 50px;
  background-color: var(--close-background-color);
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  gap: 32px;
}
.links{
  display: flex;
  gap: 16px;
}
footer img {
  width: 200px;
  height: 200px;
  justify-self: center;
  object-fit: cover;
}
.contact-info {
  display: grid;
  justify-items: start;
  justify-content: center;

}
@media (min-width: 1024px) and (hover: hover) {
  .about-me > * {
    flex: 1;
  }
  .about-me {
    padding: 25px;
    padding-right: 32px;
    display: flex;
    flex-direction: column;
  }
  .about-me h1 {
    font-size: 2.5rem;
    margin-bottom: 16px;
  }
  header {
    display: flex;
    align-items: center;
    padding: 64px;
  }
  picture {
    width: 500px;
    height: 500px;
    margin-right: 0;
    transform-origin: right;
    aspect-ratio: 1 / 1;
  }
  .header-wrap::after {
    bottom: 35%;
  }
  picture img {
    width: 500px;
    height: 500px;
  }
  .project-card img {
  color: var(--primary-color);
  text-decoration: none;
  filter: grayscale(60%);
  filter: blur(4px);
}
.project-card img:hover {
  filter: grayscale(0%);
  filter: blur(0px);
  transition: filter 0.2s ease-out;
}

}

@media (min-width: 768px) and (hover: none) {
  header img {
    margin: 0px 24px 0px 50px;
    float: left;
    width: 300px;
    height: 300px;
    transform: scale(1.2);
    transform-origin: bottom right;
  }
  header {
    padding: 128px 32px 16px 32px;
  }
  .about-me {
    margin-left: 128px;
    padding: 32px;
    max-width: 600px;
    text-wrap: pretty;
  }
  .about-me h1 {
    font-size: 2rem;
    margin-left: 30px;
    margin-bottom: 16px;
  }
  .about-me p {
    margin-left: 30px;
  }
  .header-wrap::after {
    bottom: 55%;
  }
  .name-overlay {
    top: 4rem;
    left: 50%;
  }

}

@media (max-width: 767px) {
  header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  header img {
    justify-self: center;
    width: 250px;
    height: 250px;
    margin-bottom: 50px;
    margin-top: 50px;
  }
  picture {
    position: relative;
    width: 250px;
    height: 250px;
    margin-bottom: 100px;
    transform-origin: right;
    aspect-ratio: 1 / 1;
  }
    .name-overlay {
      bottom: 0;
      left: 8%;
      font-size: 1.5rem;
      transform: translateY(650%)
  }
  .header-wrap::after {
    bottom: 45%;
  }
  .about-me {
    display: flex;
    flex-direction: column;
    margin: 16px;
    padding: 16px;
    align-items: flex-end;
    font-size: 0.875rem;
  }
  #projects{
    justify-content: center;
  }
  footer {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }
  footer img {
    display: none;
  }

}
@media (max-width: 550px) {
    .header-wrap::after {
    bottom: 25%;
  }

}

`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,SAAS;EACT,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;;AAEzB;AACA;EACE;IACE,OAAO;EACT;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;EACA,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;AAEA;EACE;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;IACT,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;EACrB;IACE;MACE,SAAS;MACT,QAAQ;MACR,iBAAiB;MACjB;EACJ;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;EACA;IACE,aAAa;EACf;;AAEF;AACA;IACI;IACA,WAAW;EACb;;AAEF","sourcesContent":["/* Add your styles here */\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n*:not(dialog) {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\n:root {\n  font-size: 16px;\n  --far-background-color: #eeeeee;\n  --close-background-color: #cccccc;\n  --primary-color: #020100;\n  --secondary-color: #801a86;\n  --accent-color: #e768f3;\n}\nbody {\n  background-color: var(--far-background-color);\n  font-family: \"Space Grotesk\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\nheader {\n  position: relative;\n  max-width: 1300px;\n}\n.header-wrap::after {\n  content: \"\";\n  position: absolute;\n  background-color: var(--secondary-color);\n  transform: skewY(-10deg);\n  transform-origin: top left;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n.header-wrap::after{\n  animation: appear 1s ease-in-out forwards;\n}\n@keyframes appear {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.socials ul {\n  list-style: none;\n  display: flex;\n  gap: 16px;\n}\n.socials {\n  margin-top: 16px;\n  align-self: flex-end;\n  width: max-content;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.about-me {\n  background-color: var(--close-background-color);\n  height: max-content;\n  justify-content: center;\n  align-items: flex-end;\n}\n.name-overlay {\n  position: absolute;\n  color: var(--primary-color);\n  font-size: 2.5rem;\n  font-weight: bold;\n  width: max-content;\n  text-shadow: 4px 4px var(--accent-color);\n  z-index: 3;\n  top: 4rem;\n  left: 12%;\n  height: max-content;\n}\n.about-me h1 {\n  height: max-content;\n}\nmain {\n  width: 98vw;\n}\n.project-card {\n  height: 350px;\n  width: 320px;\n  background-color: var(--far-background-color);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: #020100 solid 4px;\n  font-size: 0.875rem;\n}\n.project-link{\n  display: flex;\n  gap: 16px;\n}\n#projects{\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap:16px;\n  justify-items: center;\n}\n.my-work {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  align-items: center;\n  padding: 16px;\n}\n.my-work h1 {\n  font-size: 3rem;\n  align-content: center;\n}\n.project-card-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.project-card-head h1 {\n  font-size: 1.5rem;\n}\n.project-card-content {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\nfooter {\n  margin-top: 32px;\n  padding: 50px;\n  background-color: var(--close-background-color);\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  justify-content: center;\n  align-items: center;\n  gap: 32px;\n}\n.links{\n  display: flex;\n  gap: 16px;\n}\nfooter img {\n  width: 200px;\n  height: 200px;\n  justify-self: center;\n  object-fit: cover;\n}\n.contact-info {\n  display: grid;\n  justify-items: start;\n  justify-content: center;\n\n}\n@media (min-width: 1024px) and (hover: hover) {\n  .about-me > * {\n    flex: 1;\n  }\n  .about-me {\n    padding: 25px;\n    padding-right: 32px;\n    display: flex;\n    flex-direction: column;\n  }\n  .about-me h1 {\n    font-size: 2.5rem;\n    margin-bottom: 16px;\n  }\n  header {\n    display: flex;\n    align-items: center;\n    padding: 64px;\n  }\n  picture {\n    width: 500px;\n    height: 500px;\n    margin-right: 0;\n    transform-origin: right;\n    aspect-ratio: 1 / 1;\n  }\n  .header-wrap::after {\n    bottom: 35%;\n  }\n  picture img {\n    width: 500px;\n    height: 500px;\n  }\n  .project-card img {\n  color: var(--primary-color);\n  text-decoration: none;\n  filter: grayscale(60%);\n  filter: blur(4px);\n}\n.project-card img:hover {\n  filter: grayscale(0%);\n  filter: blur(0px);\n  transition: filter 0.2s ease-out;\n}\n\n}\n\n@media (min-width: 768px) and (hover: none) {\n  header img {\n    margin: 0px 24px 0px 50px;\n    float: left;\n    width: 300px;\n    height: 300px;\n    transform: scale(1.2);\n    transform-origin: bottom right;\n  }\n  header {\n    padding: 128px 32px 16px 32px;\n  }\n  .about-me {\n    margin-left: 128px;\n    padding: 32px;\n    max-width: 600px;\n    text-wrap: pretty;\n  }\n  .about-me h1 {\n    font-size: 2rem;\n    margin-left: 30px;\n    margin-bottom: 16px;\n  }\n  .about-me p {\n    margin-left: 30px;\n  }\n  .header-wrap::after {\n    bottom: 55%;\n  }\n  .name-overlay {\n    top: 4rem;\n    left: 50%;\n  }\n\n}\n\n@media (max-width: 767px) {\n  header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  header img {\n    justify-self: center;\n    width: 250px;\n    height: 250px;\n    margin-bottom: 50px;\n    margin-top: 50px;\n  }\n  picture {\n    position: relative;\n    width: 250px;\n    height: 250px;\n    margin-bottom: 100px;\n    transform-origin: right;\n    aspect-ratio: 1 / 1;\n  }\n    .name-overlay {\n      bottom: 0;\n      left: 8%;\n      font-size: 1.5rem;\n      transform: translateY(650%)\n  }\n  .header-wrap::after {\n    bottom: 45%;\n  }\n  .about-me {\n    display: flex;\n    flex-direction: column;\n    margin: 16px;\n    padding: 16px;\n    align-items: flex-end;\n    font-size: 0.875rem;\n  }\n  #projects{\n    justify-content: center;\n  }\n  footer {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px;\n  }\n  footer img {\n    display: none;\n  }\n\n}\n@media (max-width: 550px) {\n    .header-wrap::after {\n    bottom: 25%;\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
